<template>
<div>
    <v-menu v-model="menuWidget" :close-on-content-click="false" :nudge-width="200" offset-x>
        <template v-slot:activator="{ on }">
            <v-btn v-on="on"><v-icon medium>fa-tag</v-icon> <v-icon right dark>arrow_drop_down</v-icon></v-btn>
        </template>
        <v-card>
            <v-list>
                <template v-for="item in allFlags" >
                    <v-list-item v-bind:key="item.ID">
                        <v-list-item-action>
                            <v-switch v-model="item.Checked" :color="item.FlagColor" @change="updateFlag(item)" :disabled="purchaseRole && !item.Checked"></v-switch>
                        </v-list-item-action>
                        <v-list-item-title>{{item.FlagName}}</v-list-item-title>
                        <v-list-item-avatar>
                            <v-icon medium :color="item.FlagColor">fa-tag</v-icon> 
                        </v-list-item-avatar>
                    </v-list-item>
                </template>
            </v-list>
        </v-card>
    </v-menu>
    <v-dialog v-model="dialogCancelOrder" max-width="300px">
        <v-card>
            <v-card-title>
            <span class="title">Xác nhận hủy tag</span>
            </v-card-title>
            <v-card-text>
            <v-container grid-list-md pa-0>
                <v-layout row wrap>
                <v-flex lg12>
                    <h-currency-input label="Số ngày gia hạn" v-model="extendDay" :decimal="0"></h-currency-input>
                </v-flex>
                </v-layout>
            </v-container>
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1 white--text" @click="cancelUpdate">Đóng</v-btn>
            <v-btn color="red darken-1 white--text" @click="confirmUpdate">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
export default {
    name: 'order-flag-menu',
    props: {
        orderID: {
            type: Number,
            default: 0
        },
        orderType: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            menuWidget: false,
            dialogCancelOrder: false,
            extendDay: 0,
            currentItem: null
        }
    },
    methods: {
        updateFlag: _.debounce(
            function(item) {
                if(item.Checked && item.ID == null) {
                    this.$store.dispatch("orderFlag/setDetail", {
                        data: {
                            OrderID: this.orderID,
                            OrderType: this.orderType,
                            FlagID: item.FlagID
                        },
                        id: 0
                    });
                }
                else if(!item.Checked && item.ID > 0) {
                    if (item.FlagType > 0) {
                        this.extendDay = 0;
                        this.currentItem = item;
                        this.dialogCancelOrder = true;
                    } else {
                        this.$store.dispatch("orderFlag/removeDetail", {id: item.ID, orderID: this.orderID, orderType: this.orderType});
                    }
                }
            },
            300,
            {
                leading: true,
                trailing: false
            }
        ),
        confirmUpdate() {
            this.$store.dispatch("orderFlag/setDetail", {
                data: {
                    VisibleDetailOrder: 0,
                    ExtendDay: this.extendDay
                },
                id: this.currentItem.ID
            });
            this.currentItem = null;
            this.dialogCancelOrder = false;
        },
        cancelUpdate() {
            this.dialogCancelOrder = false; 
            this.currentItem = null;
            this.$store.dispatch("orderFlag/getList", {'OrderID': this.orderID, 'OrderType': this.orderType});
        }
    },
    computed: {
        ...mapState({
            allFlags: state => state.orderFlag.all.data,
        }),
        purchaseRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Purchase;
        }
    }
}
</script>
